/**
 * history.push(path, [state])
 * history.replace(path, [state])
 * history.go(n)
 * history.goBack()
 * history.goForward()
 *
 * history.listen(func) // listen for changes to the current location
 *
 */
import { createBrowserHistory } from 'history';
const HISTORY = createBrowserHistory({
  basename: '/'
});
export default HISTORY;